// Konto-API (Anmeldung per Cookie) und Svelte-Store mit dem angemeldeten Konto.
import { writable } from 'svelte/store';
import type { AvatarSpec } from '../../shared/avatar.ts';

export interface AccountView {
  username: string;
  nickname: string;
  avatar: AvatarSpec;
  team: string;
}

export const account = writable<AccountView | null>(null);
export const accountChecked = writable(false);

async function call<T>(method: string, url: string, body?: unknown): Promise<T> {
  const r = await fetch(url, { method, headers: body !== undefined ? { 'content-type': 'application/json' } : {}, body: body !== undefined ? JSON.stringify(body) : undefined, credentials: 'same-origin' });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw Object.assign(new Error(j.error ?? 'Fehler ' + r.status), { status: r.status, body: j });
  return j as T;
}

export async function refreshAccount(): Promise<AccountView | null> {
  try {
    const a = await call<AccountView>('GET', '/api/account/me');
    account.set(a);
    return a;
  } catch {
    account.set(null);
    return null;
  } finally {
    accountChecked.set(true);
  }
}

export async function register(username: string, password: string, nickname: string, avatar: AvatarSpec) {
  const a = await call<AccountView>('POST', '/api/account/register', { username, password, nickname, avatar });
  account.set(a);
  return a;
}
export async function login(username: string, password: string) {
  const a = await call<AccountView>('POST', '/api/account/login', { username, password });
  account.set(a);
  return a;
}
export async function logout() {
  await call('POST', '/api/account/logout');
  account.set(null);
}
export async function updateProfile(f: Partial<Pick<AccountView, 'nickname' | 'avatar' | 'team'>>) {
  const a = await call<AccountView>('PUT', '/api/account/profile', f);
  account.set(a);
  return a;
}
export const getCloudSave = () => call<{ data: CloudData | null; updatedAt: number }>('GET', '/api/account/save');
export const putCloudSave = (data: CloudData, updatedAt: number) => call<{ ok: true; updatedAt: number }>('PUT', '/api/account/save', { data, updatedAt });

export interface CloudData {
  profile: unknown;
  saves: unknown[];
  local: Record<string, string>;
}
